export type DevUpdateBadgeVariant =
	| "done"
	| "high"
	| "urgent"
	| "review"
	| "default";

export const TYPE_VARIANT: Record<string, DevUpdateBadgeVariant> = {
	Feature: "done",
	Fix: "urgent",
	Enhancement: "review",
	Perf: "high",
};

export function formatDate(value: string): string {
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return value;
	return d.toLocaleDateString(undefined, {
		year: "numeric",
		month: "short",
		day: "numeric",
	});
}

// Normalize a date string to a YYYY-MM-DD bucket key (local time).
export function dayKey(value: string): string {
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return value.slice(0, 10);
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${y}-${m}-${day}`;
}
